/* eslint-disable array-callback-return */

import React from "react";
import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Select from "react-select";

const AddApplication = (props) => {
  // const { apps } = props
  // console.log(props)
  const [show, setShow] = useState(false);
  const [validated, setValidated] = useState(false);
  // const [apps, setApps] = useState(null)
  const [appValue, setAppValue] = useState(null);
  const [options, setOptions] = useState([]);
  // const [appList, setAppList] = useState([])
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);
  const [isCheckAll, setIsCheckAll] = useState(false);

  const [permissions, setPermissionsValue] = useState([]);
  const handleMarkComplete = (index, value) => {
    const updatedPer = {
      ...appValue.permissions[index],
      is_enable: !value.is_enable,
    };

    const newPermission = [...appValue.permissions];
    newPermission[index] = updatedPer;
    setAppValue({ ...appValue, permissions: newPermission });
    // setPermissionValue(newPermission);
  };

  const handleDone = () => {
    if (appValue === null || appValue === "") {
      setValidated(true);
      return false;
    } else {
      props.setApps(appValue, permissions);
      handleClose();
    }
  };
  const handleSelectAll = (e) => {
    setIsCheckAll(!isCheckAll);

    // setIsCheck(appValue.permissions.map(li => li.id));
    if (isCheckAll) {
      const newPermission = [];
      for (let i = 0; i < appValue.permissions.length; i++) {
        newPermission[i] = { ...appValue.permissions[i], is_enable: false };
      }
      setAppValue({ ...appValue, permissions: newPermission });
    } else {
      const newPermission = [];
      for (let i = 0; i < appValue.permissions.length; i++) {
        newPermission[i] = { ...appValue.permissions[i], is_enable: true };
      }

      // newPermission = updatedPer;
      setAppValue({ ...appValue, permissions: newPermission });
    }
  };

  useEffect(() => {
    setAppValue(null);
    setValidated(false);
    let datas = [];
    props.appList.map((app) => {
      datas.push({ value: app.id, label: app.name, id: app.id });
    });
    setOptions(datas);
  }, [props]);
  // useEffect(() => {
  //     function reqApps() {
  //         reqAppList().then(res => {
  //             setAppList(res.result)
  //             if (res.result.length > 0) {
  //                 setAppValue(res.result[0].id)
  //             }
  //         }).catch(_err => {

  //         })
  //     }
  //     reqApps()
  //     // requestPermissions()
  // }, [props])
  return (
    <>
      <Button variant="primary" onClick={handleShow} className="border">
        Add Application
      </Button>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          {/* <Modal.Title>Modal heading</Modal.Title> */}
          <h5>Service Permission</h5>
        </Modal.Header>
        <Modal.Body>
          <Form noValidate validated={validated}>
            <div className="d-flex justify-content-start">
              <div className="col-md-12">
                <div className="form-group w-75">
                  <label htmlFor="InputApp">Application Access</label>
                  <Select
                    isSearchable={true}
                    options={options}
                    placeholder="เลือกแอพ"
                    noOptionsMessage={() => "ไม่พบแอพ"}
                    onChange={(e) => {
                        const x = props.appList.find(
                          (x) => x.id === e.value
                        );
                        console.log(x)
                        setAppValue(x);
                        setPermissionsValue(x.permissions);
                      }}
                  />
                  {/* <Form.Control
                    as="select"
                    defaultValue={appValue?.id}
                    onChange={(e) => {
                      const x = props.appList.find(
                        (x) => x.id === e.target.value
                      );
                      setAppValue(x);
                      setPermissionsValue(x.permissions);
                    }}
                    required
                  >
                    <option value={""}>เลือกแอพ</option>
                    {props.appList.map((app) => {
                      return (
                        <option value={app.id} key={app.id}>
                          {app.name}
                        </option>
                      );
                    })}
                  </Form.Control> */}
                </div>
                {/* <div className="form-group">
                                    <label htmlFor="InputApp" className='mb-0'>Permission Access</label>
                                    <ul className="list-group list-group-flush">
                                        
                                        {appValue !== null ? appValue.permissions !== undefined ? appValue.permissions.map((p, i) =>
                                        (
                                            <>
                                                {i === 0 ? <li className="list-group-item pl-4 py-2">
                                                    <label htmlFor={`custom-checkbox`} className="mb-0 d-flex justify-content-between align-items-center mr-3">
                                                        <label htmlFor={`custom-checkbox`} className='mb-0'>All</label>
                                                        <div className="chiller_cb">
                                                            <input
                                                                id={`custom-checkbox`}
                                                                type="checkbox"
                                                                checked={isCheckAll}
                                                                onChange={(e) => handleSelectAll(e)} 
                                                            />
                                                            <span></span>
                                                        </div>
                                                    </label>
                                                </li> :null} 
                                                <li className="list-group-item pl-4 py-2" key={i}>
                                                    <label htmlFor={`custom-checkbox-${i}`} className="mb-0 d-flex justify-content-between align-items-center mr-3">
                                                        <label htmlFor={`custom-checkbox-${i}`} className='mb-0'>{p.name}</label>
                                                        <div className="chiller_cb">
                                                            <input
                                                                id={`custom-checkbox-${i}`}
                                                                type="checkbox"
                                                                checked={p.is_enable}
                                                                onChange={() => handleMarkComplete(i, p)}
                                                            />
                                                            <span></span>
                                                        </div>
                                                    </label>
                                                </li>
                                            </>

                                        )) : [] : []}
                                    </ul>
                                </div> */}
                {/* </form> */}
              </div>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-light"
            className="text-dark border px-4"
            onClick={handleClose}
          >
            Cancel
          </Button>
          {/* <Button variant="primary" className="px-4" onClick={() => {
                        props.setApps(appValue)
                        handleClose()
                    }}> */}
          <Button variant="primary" className="px-4" onClick={handleDone}>
            Done
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddApplication;
